import { Box, Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { IMaterialDetailsDialogProps } from '../../interfaces';

export const MaterialDetails: React.SFC<IMaterialDetailsDialogProps> = ({
    material,
    onChangeTab,
    ...props
}: IMaterialDetailsDialogProps) => {

    const getPropertyValue = (property: string | null | undefined) => {
        if (property && property.length > 0)
            return property;

        return "-";
    }
    const getDateValue = (property: Date | string | null | undefined) => {

        if (typeof (property) === 'string')
            property = new Date(property);

        if (property)
            return property.toLocaleDateString("en-GB");

        return "-";
    }

    return (

        <Grid container >
            <Grid item xs={3} paddingRight={1}>
                <Typography className="material-property-text">
                    <strong>Level 1 Description</strong> {material.l1?.value}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Level 2 Description</strong> {material.l2?.value}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Level 3 Description</strong> {material.l3}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Porterbrook Asset Number</strong> {getPropertyValue(material.porterbrookAssetNumber)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Part Number</strong> {getPropertyValue(material.partNumber)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Catalogue Number</strong> {getPropertyValue(material.catalogueNumber)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Serial Number</strong> {getPropertyValue(material.serialNumber)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Manufacturer Number</strong> {getPropertyValue(material.manufacturerNumber)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Unit Number</strong> {getPropertyValue(material.unitNumber)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Vehicle Number</strong> {getPropertyValue(material.vehicleNumber)}
                </Typography>
            </Grid>
            <Grid item xs={3} paddingRight={1} >
                <Typography className="material-property-text">
                    <strong>Vehicle Class(es)</strong> {material.vehicleClasses?.map(x => x.value).join(", ")}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Spare Type</strong> {getPropertyValue(material.spareType?.value)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Status</strong> {getPropertyValue(material.state?.value)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Owned By</strong> {getPropertyValue(material.ownedBy)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Contract</strong> {getPropertyValue(material.contractReference)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Storage Request </strong> {getPropertyValue(material.storageRequestReference)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Paperwork Recieved </strong> {getPropertyValue(material.paperWorkReceived)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Restricted Use</strong> {getPropertyValue(material.hasUsageRestrictions)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Weight Estimate <small style={{ color: 'grey' }}>(per qty)</small></strong> {material.weightEstimate}kg
                </Typography>
                <Typography className="material-property-text">
                    <strong>Value Estimate</strong> £{material.valueEstimate}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Total <small>(x{material.quantity})</small></strong> £{material.totalValueEstimate}
                </Typography>
            </Grid>
            <Grid item xs={3} paddingRight={1} >


                <Typography className="material-property-text">
                    <strong>Site</strong> {getPropertyValue(material.site?.value)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Warehouse</strong> {getPropertyValue(material.warehouse?.value)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Storage Type</strong> {getPropertyValue(material.storageType?.value)}
                </Typography>
                <Grid container>
                    <Grid item xs={6}>
                        <Typography className="material-property-text">
                            <strong>Rack</strong> {getPropertyValue(material.rack)}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography className="material-property-text">
                            <strong>Row</strong> {getPropertyValue(material.row)}
                        </Typography>
                    </Grid>
                </Grid>
                <Typography className="material-property-text">
                    <strong>Pallet Number</strong> {getPropertyValue(material.pallet)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Arrival Date</strong> {getDateValue(material.arrivalDate)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Expiry Date</strong> {getDateValue(material.partExpiry)}
                </Typography>
                <Typography className="material-property-text">
                    <strong>Quantity</strong> {`${material.quantity} (${material.unitOfQuantity.value})`}
                </Typography>
            </Grid>
            <Grid item xs={3} display="flex" justifyContent="flex-end">
                <Tooltip title="click to view all photos for this material">
                    {material.images.length > 0 ?
                        <img
                            className="image-thumbnail"
                            onClick={() => onChangeTab && onChangeTab(1)}
                            src={material.images[0].src}
                            alt={"preview for this material"}
                        />
                        :
                        <Box
                            className="no-image-placeholder"
                            onClick={() => onChangeTab && onChangeTab(1)}
                        >
                            <p>No image available</p>
                        </Box>
                    }
                </Tooltip>
            </Grid>
        </Grid>
    );
}